import Close from '../lib/Close';
import ViewAll from '../lib/ViewAll';

export default function v1KansaiByRail() {
  const saElem = document.getElementsByClassName('v1-kansai-by-rail-animation');
  function scrollAddClass() {
    const ws = window.pageYOffset;
    const wh = window.innerHeight;
    const sp = ws + wh * 0.8;
    for (let i = 0; i < saElem.length; i += 1) {
      if (saElem[i].getBoundingClientRect().top + ws < sp) {
        saElem[i].classList.add('is-show');
      }
    }
  }
  window.addEventListener('scroll', scrollAddClass, false);

  const heroVideo = document
    .getElementById('v1-kansai-by-rail-hero-video')
    .getElementsByTagName('video')[0];
  const heroBtn = document.getElementById('v1-kansai-by-rail-hero__btn');
  function heroVideoCtrl() {
    if (heroBtn.classList.contains('-play')) {
      heroBtn.classList.remove('-play');
      heroBtn.classList.add('-stop');
      heroVideo.pause();
    } else {
      heroBtn.classList.remove('-stop');
      heroBtn.classList.add('-play');
      heroVideo.play();
    }
  }
  heroBtn.addEventListener('click', heroVideoCtrl, false);

  const recommendArea = document.getElementById('v1-kansai-by-rail-recommend__scroll-inner');
  const recommendBtn = document.getElementById('v1-kansai-by-rail-recommend__btn');
  function recommendScrollCtrl() {
    if (recommendBtn.classList.contains('-play')) {
      recommendBtn.classList.remove('-play');
      recommendBtn.classList.add('-stop');
      recommendArea.classList.add('is-stop');
    } else {
      recommendBtn.classList.remove('-stop');
      recommendBtn.classList.add('-play');
      recommendArea.classList.remove('is-stop');
    }
  }
  recommendBtn.addEventListener('click', recommendScrollCtrl, false);

  const whatArea = document.getElementById('what');
  const whatBtn = document.getElementById('v1-kansai-by-rail-what-view');
  const slideArea = document.getElementById('v1-kansai-by-rail-what__list-more');
  const slideEle = slideArea.getElementsByClassName('v1-cardDestination__list')[0];
  const slideSpeed = 500;
  function slideFunction(start, end) {
    let counter = 0;
    const per = Math.abs(end - start) / (slideSpeed / 10);
    const slideTimer = setInterval(function() {
      counter += 1;
      slideArea.style.height = `${Math.abs(start - per * counter)}px`;
      if (counter >= slideSpeed / 10) {
        clearInterval(slideTimer);
        slideArea.style.height = 'auto';
      }
    }, 10);
  }
  function slideDownInit() {
    const ah = slideEle.clientHeight;
    slideArea.style.height = '0px';
    slideFunction(0, ah);
  }
  function slideUpInit() {
    const bh = slideEle.clientHeight;
    slideArea.style.height = `${bh}px`;
    slideFunction(bh, 0);
    setTimeout(function() {
      whatArea.classList.remove('is-open');
      whatBtn.innerText = ViewAll.text();
    }, slideSpeed);
  }
  function whatView() {
    if (!whatArea.classList.contains('is-open')) {
      whatArea.classList.add('is-open');
      slideDownInit();
      whatBtn.innerText = Close.text();
    } else {
      slideUpInit();
    }
  }
  whatBtn.innerText = ViewAll.text();
  whatBtn.addEventListener('click', whatView, false);
}
